var _defs, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 371,
    height: 87,
    viewBox: "0 0 371 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        font-size: 471px;\n      }\n\n      .cls-1, .cls-4, .cls-5 {\n        text-anchor: middle;\n        font-family: Borsok;\n      }\n\n      .cls-2 {\n        font-size: 415px;\n      }\n\n      .cls-3 {\n        fill: #3C0D99;\n      }\n\n      .cls-4 {\n        font-size: 12px;\n      }\n\n      .cls-5 {\n        font-size: 420px;\n        fill: #fff;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\u043D\\u044F\\u043D\\u044F\\u043E\\u043A",
    className: "cls-1",
    transform: "translate(182.62 71.693) scale(0.194 0.194)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "\u043D", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2"
  }, "\u044F\u043D\u044F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3"
  }, "\u043E\u043A")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_.",
    "data-name": ".",
    className: "cls-4",
    transform: "translate(62.512 -42.393) scale(0.194 0.194)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "."))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Lorem_Ipsum",
    "data-name": "Lorem Ipsum",
    className: "cls-5",
    transform: "translate(-9.739 -42.628) scale(0.194 0.194)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "Lorem Ipsum"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae48d05cb247f6dc28fe7d5407428bdb.svg";
export { ForwardRef as ReactComponent };